var EPK = EPK || {};
EPK.NearShopList = EPK.NearShopList || {};
EPK.NearShopList.initPageStatus = EPK.NearShopList.initPageStatus || false;

EPK.PharmacySearch = EPK.PharmacySearch || {};

EPK.NearShopList.Map = EPK.NearShopList.Map || {};


/**
 * GETパラメータ生成
 */
EPK.NearShopList.getQueryStr = function($otherQuery) {
	var query = '';
	var sep = '?';
	if($("#nsl_is_net").prop('checked') || ("undefined" === typeof($("#nsl_is_net").prop('checked')) && location.search.match(/is_net=1/))) {
		query += sep + 'is_net=1';
		sep = '&';
	}
	if($("#nsl_is_open").prop('checked') || ("undefined" === typeof($("#nsl_is_open").prop('checked')) && location.search.match(/is_open=1/))) {
		query += sep + 'is_open=1';
		sep = '&';
	}
	if($("#nsl_is_receive_open").prop('checked') || ("undefined" === typeof($("#nsl_is_receive_open").prop('checked')) && location.search.match(/is_receive_open=1/))) {
		query += sep + 'is_receive_open=1';
		sep = '&';
	}
	if($("#nsl_is_coupon").prop('checked') || ("undefined" === typeof($("#nsl_is_coupon").prop('checked')) && location.search.match(/is_coupon=1/))) {
		query += sep + 'is_coupon=1';
		sep = '&';
	}
	if($otherQuery) {
		query += sep + $otherQuery;
		sep = '&';
	}
	return query;
};

EPK.NearShopList.getQueryDistanceStr = function(argQuery) {
	var sep = argQuery ? '&' : '?';
	var query = '';
	if($("#nsl_distance100").prop('checked')) {
		query += sep + 'distance=100';
	}
	if($("#nsl_distance300").prop('checked')) {
		query += sep + 'distance=300';
	}
	if($("#nsl_distance500").prop('checked')) {
		query += sep + 'distance=500';
	}
	if($("#nsl_distance1000").prop('checked')) {
		query += sep + 'distance=1000';
	}
	return query;
};

EPK.NearShopList.getQueryArr = function() {
	if($("#nsl_is_net").prop('checked')) {
		EPK.NearShopList.queryArr['is_net'] = '1';
	}
	if($("#nsl_is_open").prop('checked')) {
		EPK.NearShopList.queryArr['is_open'] = '1';
	}
	if($("#nsl_is_receive_open").prop('checked')) {
		EPK.NearShopList.queryArr['is_receive_open'] = '1';
	}
	if($("#nsl_is_coupon").prop('checked')) {
		EPK.NearShopList.queryArr['is_coupon'] = '1';
	}
	if (EPK.NearShopList.km_brand_page_id != '') {
		EPK.NearShopList.queryArr['brand_id'] = EPK.NearShopList.km_brand_page_id;	
	}

	EPK.NearShopList.getQueryLatLng();
	EPK.NearShopList.getQueryDistanceArr();

	return EPK.NearShopList.queryArr;
};

EPK.NearShopList.getQueryLatLng = function() {
	EPK.NearShopList.queryArr['lat'] = EPK.common.latlng.lat;
	EPK.NearShopList.queryArr['lng'] = EPK.common.latlng.lng;
};

EPK.NearShopList.getQueryDistanceArr = function() {
	if($("#nsl_distance100").prop('checked')) {
		EPK.NearShopList.queryArr['distance'] = '100';
	} else if($("#nsl_distance300").prop('checked')) {
		EPK.NearShopList.queryArr['distance'] = '300';
	} else if($("#nsl_distance500").prop('checked')) {
		EPK.NearShopList.queryArr['distance'] = '500';
	} else if($("#nsl_distance1000").prop('checked')) {
		EPK.NearShopList.queryArr['distance'] = '1000';
	} else {//距離未チェック
		EPK.NearShopList.queryArr['distance'] = EPK.NearShopList.km_brand_page_id ? 5000 : 1000; 
	}
	return EPK.NearShopList.queryArr;
};

/**
 * 再検索用のリクエストURL成形
 */
EPK.NearShopList.getActionUrl = function($needQuery) {
	var locationObj = window.location;
	var url_km = locationObj.protocol + '//' + locationObj.hostname;
	var url_here = url_km + locationObj.pathname;
	var query = ''
	if($needQuery) {
		query = EPK.NearShopList.getQueryStr();
		query += EPK.NearShopList.getQueryDistanceStr(query); 
	}
	var url_action = url_here + query;
	return url_action;
};

/**
 * POST処理（緯度経度）
 */
EPK.NearShopList.postCoordinates = function($lat, $lng) {
	var url_action = EPK.NearShopList.getActionUrl(true);

	$('#nsl-input-lat').val($lat);
	$('#nsl-input-lon').val($lng);
	$("form#nsl-form").attr("action", url_action);
	$("form#nsl-form").submit();
};

/**
 * 現在地取得エラーメッセージの表示処理
 */
EPK.NearShopList.replaceMsgBox = function() {
	function funcMobile() {
		//$msg = $msg + '<p>※上部メニューから再検索できます。</p>';
		$msgBox.innerHTML = $msg;
		if(document.getElementsByClassName('near-noshop-search').length == 0) {
			var $btn_node = document.createElement('div');
			$btn_node.setAttribute('class', 'near-noshop-search near-retry-btn');
			$btn_node.innerHTML = '<a href="'+$url+'" class="GA_near_retry">再試行</a>';
			$msgBox.parentNode.insertBefore($btn_node, $msgBox.nextSibling);
		}
	}
	function funcPC() {
		var $btn = '<div class="near-noshop-search near-retry-btn"><a href="'+$url+'" class="GA_near_retry">再試行</a></div>';
		$msgBox.innerHTML = $msg + $btn;
	}
	var $url = EPK.NearShopList.getActionUrl(true);
	var $msgBox = document.getElementById('nsl-text-box');
	var $msg = '位置情報の取得に失敗しました。<br>端末のインターネット接続および位置情報サービスの設定をご確認の上、もう一度お試しください。';
	if($msgBox != null) {
		if(EPK.NearShopList.isMobile) {
			$msg = '位置情報の取得に失敗しました。<br>端末のインターネット接続および位置情報サービスの<br>設定をご確認の上、もう一度お試しください。';
			funcMobile();
		}else {
			funcPC();
		}
	}else {
		EPK.NearShopList.postCoordinates(null, null);
	}
};

/**
 * 現在地（緯度経度）取得処理
 * ※※位置情報取得できない場合のハンドリングが必要なので
 * ※※共通処理(EPK.common.currentPlaceCallback)は利用しない
 *
 */
EPK.NearShopList.getLocation = function(){
	function successFunc(position) {
		var $data = position.coords ;
		var $lat = $data.latitude;
		var $lng = $data.longitude;
		EPK.NearShopList.postCoordinates($lat, $lng);
	}
	function errorFunc() {
		EPK.NearShopList.replaceMsgBox();
	}
	var optionObj = {
			"enableHighAccuracy": true,
			"timeout": 8000,
			"maximumAge": 2000,
	};
	// Geolocation APIの対応判定
	if(navigator.geolocation) {
		// 現在位置を取得
		navigator.geolocation.getCurrentPosition(successFunc, errorFunc, optionObj);
	}else {
		// 設定促進エラーメッセージ表示
		errorFunc();
	}
};

/**
 * PC：再検索用のModal
 * 近くの薬局「検索条件を変更」用に初期表示時の件数を取得
 * してModal検索ボタンの件数枠へセットする
 */
EPK.NearShopList.setModalInitCnt = function() {
	var $form = $('#popup_reserch-conditions');
	var btnID = $form.attr("data-btnId");
	var $cntElm = $('#'+btnID+' span#shop_count');
	var query = $form.serialize();
	var callback = function(data) {
		$cntElm.html(data)
	}
	EPK.PharmacySearch.getCountByQuery(query, callback);
};


/**
 * SP：再検索用のModal
 * 条件毎の件数を取得しボタンを非活性化する
 */
EPK.NearShopList.setDisable = function(query,target) {
	var callback = function(data) {
		if ( data === 0 ) {
			$(target).prop('disabled', true);
		}
	}
	EPK.PharmacySearch.getCountByQuery(query, callback);
};

/**
 * map 表示
 */
EPK.NearShopList.Map.init = function() {
	// マーカーのサイズ
	if(EPK.NearShopList.isMobile) {
		var arg = {
				marker_here: {w: 17, h: 17},
				marker: {w: 21, h: 30}
		};
	}else {
		var arg = {
				marker_here: {w: 17, h: 17},
				marker: {w: 32, h: 44}
		};
	}
	var canvas = document.getElementById('map-canvas');
	var lat = canvas.getAttribute('data-lat');
	var lng = canvas.getAttribute('data-lng');
	var latlng = new google.maps.LatLng(lat, lng);
	var mapOptions = {
			zoom: EPK.NearShopList.Map.zoomLv,
			center: latlng,
			panControl: false,
			zoomControl: false,
			scaleControl: false,
			streetViewControl: false,
			mapTypeControl: false,
			gestureHandling: 'greedy',
	};
	var map = new google.maps.Map(canvas, mapOptions);
	if(map){
		var markers = EPK.NearShopList.Map.markers;
		var markerSize = new google.maps.Size(arg.marker_here.w, arg.marker_here.h);

		markers.forEach(function(pin, key) {
			if(key == 0 && EPK.NearShopList.isMobile == false) {
				return; // PCは現在地マーカーを表示しない
			}
			if(key == 1) {
				markerSize = new google.maps.Size(arg.marker.w, arg.marker.h);
			}
			// マーカー
			var marker = new google.maps.Marker({
				map: map,
				position: pin.latlng,
				icon: {
					url: pin.iconImg,
					scaledSize: markerSize
				},
				animation: google.maps.Animation.DROP
			});
			if(key > 0) {
				// マーカーのクリックイベント設定
				google.maps.event.addListener(marker, 'click', (function(anchor){
					return function(){ location.hash = anchor; };
				})(pin.anchor));
			}
		});
	}
};




/**
 * ------------------
 *
 * MAIN 処理
 *
 * ------------------
 */
$(function(){
	// 初期表示で緯度経度取得
	if(EPK.NearShopList.initPageStatus) {
		EPK.NearShopList.getLocation();
	}

	// 絞り込み条件変更時に再検索
	$('input[type=checkbox][name=nsl-search]').on('change', function(e) {
		//e.preventDefault();
		EPK.NearShopList.getLocation();
	});

	$('input[type=radio][name=nsl-search]').on('change', function(e) {
		//e.preventDefault();
		EPK.NearShopList.getLocation();
	});

	// 距離ラジオボタン制御(近くのブランドのみ)
	if (EPK.NearShopList.km_brand_page_id != '') {
		$('input[type=radio][name=nsl-search]:checked').on('click', function(e) {
			$(this).prop('checked', false);
			EPK.NearShopList.getLocation();
		});
	}

	// 現在地の再取得ボタン
	$('.retry-get-coordinates-btn').on('click', function(e) {
		//e.preventDefault();
		EPK.NearShopList.getLocation();
	});

	if(EPK.NearShopList.isMobile) {
		// 駅・路線 / エリアから探す ボタン
		$('#research-km-station-btn, #research-km-area-btn').on('click', function(e) {
			//e.preventDefault();
			var href = this.getAttribute('data-href');
			if (EPK.NearShopList.km_brand_page_id == '') {
				var mode = this.getAttribute('data-query');
				var query = EPK.NearShopList.getQueryStr(mode);
				href = href + query;
			}
			window.location.href = href;
		});
	}else {
		// 検索条件を変更 ボタン
		$('#modal-select-change-btn').on('click', function(e) {
			//e.preventDefault();
			EPK.NearShopList.setModalInitCnt();
		});
	}
	// google map 表示
	if(EPK.NearShopList.needMap) {
		EPK.NearShopList.Map.init();
	}

	//未チェックの距離とチェック済みの条件でAjax検索
	$("input[id^=nsl_distance]:not(:checked)").each( function() {
		EPK.NearShopList.queryArr = {};
		EPK.NearShopList.getQueryArr();
		EPK.NearShopList.queryArr['distance'] = $(this).data('distance');
		query = $.param(EPK.NearShopList.queryArr);
		EPK.NearShopList.setDisable(query, this);
	});

	//未チェックの条件 + チェック済条件 + チェック(済or未)距離でAjax検索
	$("input[id^=nsl_is]:not(:checked)").each( function() {
		EPK.NearShopList.queryArr = {};
		var qKey = $(this).attr('id').replace('nsl_', '');
		EPK.NearShopList.queryArr[qKey] = 1;
		EPK.NearShopList.getQueryArr();
		query = $.param(EPK.NearShopList.queryArr);
		EPK.NearShopList.setDisable(query, this);
	});
});
